var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customers"},[_c('CurrVersions'),_c('h1',[_vm._v("Customers")]),_c('div',{staticClass:"table-wrapper loader-container"},[_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Customer Name',
          field: 'customerName'
        },
        {
          label: 'Type',
          field: 'type',
          filterOptions: {
            enabled: true,
            placeholder: 'Select',
            filterDropdownItems: ['LIVE', 'TEST', 'INACTIVE'],
            filterValue: 'LIVE'
          }
        },
        {
          label: 'Target Version',
          field: 'targetVersion',
          filterOptions: {
            enabled: true,
            placeholder: 'Select',
            filterDropdownItems: ['Alpha', 'Beta', 'Release', 'Stable']
          }
        },
        {
          label: 'Current Version',
          field: 'currentVersion',
          sortFn: this.sortVersion
        }
      ],"rows":_vm.customers},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'customerName')?_c('span',[_c('router-link',{attrs:{"to":{
              name: 'Customer',
              params: { customerId: props.row.customerId }
            }}},[_vm._v(_vm._s(props.row.customerName)+" ")])],1):_c('span',[_vm._v(" "+_vm._s(props.formattedRow[props.column.field])+" ")])]}}])}),_c('Loader',{attrs:{"loading":_vm.loadingCustomers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }